import { render, staticRenderFns } from "./UserProfit.vue?vue&type=template&id=1da3cf20&scoped=true&"
import script from "./UserProfit.vue?vue&type=script&lang=js&"
export * from "./UserProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da3cf20",
  null
  
)

export default component.exports